import React from 'react';
import { Navigate } from 'react-router-dom';
import { useProfile } from '../../hooks/useProfile';
import DesktopOnlyRoute from './DesktopOnlyRoute';
import PageLoader from './PageLoader';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
  const { data: profile, isLoading } = useProfile();
  if (isLoading) {
    return <PageLoader />;
  }

  const hasAdminAccess = profile?.is_system_admin || profile?.is_user_manager || false;

  if (!hasAdminAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <DesktopOnlyRoute title="Админ-панель недоступна">
      {children}
    </DesktopOnlyRoute>
  );
};

export default ProtectedAdminRoute;
